import { AppUrls } from 'shared/config/model/urls';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TypedDispatch } from 'shared/model/types';
import {oauthInit, oauthFinish} from 'entities/user';

export const useOAuthPopup = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const dispatch = useDispatch<TypedDispatch>();
    const navigate = useNavigate();

    const initOAuth = async(provider = 'yandex') => {
        try {
            setIsLoading(true);
            setError(null);

            const result = await dispatch(oauthInit({ provider }));

            if (!oauthInit.fulfilled.match(result)) {
                throw new Error('Не удалось получить ссылку');
            }

            const { url } = result.payload;

            const popup = window.open(
                url,
                'oauth-popup',
                'width=600,height=700,left=200,top=200',
            );

            const handleMessage = async(event: MessageEvent) => {
                if (event.origin !== window.location.origin) return;

                // eslint-disable-next-line camelcase
                const { type, code, state, timezone, device_id } = event.data;

                if (type === 'OAUTH_SUCCESS' && code && state) {
                    window.removeEventListener('message', handleMessage);
                    clearInterval(checkPopupClosed);
                    popup?.close();

                    const finishResult = await dispatch(oauthFinish({
                        provider,
                        code,
                        state,
                        timezone,
                        // eslint-disable-next-line camelcase
                        device_id,
                    }));

                    if (oauthFinish.fulfilled.match(finishResult)) {
                        navigate(AppUrls.HTTP_MONITORS);
                    } else {
                        throw new Error('Ошибка авторизации');
                    }
                }
            };

            window.addEventListener('message', handleMessage);

            const checkPopupClosed = setInterval(() => {
                if (popup?.closed) {
                    clearInterval(checkPopupClosed);
                    window.removeEventListener('message', handleMessage);
                    setIsLoading(false);
                    setError('Повторите попытку');
                }
            }, 500);

        } catch (err) {
            setError(err instanceof Error ? err.message : 'Ошибка авторизации');
            setIsLoading(false);
        }
    };

    return { initOAuth, isLoading, error };
};